export const getAltItemDescription = (businessCategories, business_category_id, itemGroupId) => {
  return businessCategories?.[business_category_id].alternate_item_descriptions?.[itemGroupId];
}

export const loadingErrorHandler = (errorState, errorID, errorCallback) => {
  if(!errorState){
    errorCallback(errorID);
  }
}